// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"UsuariosTable_spinnerContainer__bDI8j","botonAdd":"UsuariosTable_botonAdd__MuFUr","botonDetalles":"UsuariosTable_botonDetalles__hQpsE"};